import { FormControlSizes, Icon, IconButton, IconName, Text, Tooltip } from '@talos/kyoko';

import { CardFooter, CardFooterPagination, CardFooterSide, FooterNavButton } from './styles';

interface PredictionCardFooterProps {
  pageIndex: number;
  pageCount: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

export function PredictionCardFooter({ pageIndex, pageCount, onPreviousPage, onNextPage }: PredictionCardFooterProps) {
  const showPagination = pageCount > 1;

  return (
    <CardFooter data-testid="prediction-card-footer">
      <CardFooterSide />
      <CardFooterPagination>
        {showPagination ? (
          <>
            <FooterNavButton
              onClick={onPreviousPage}
              disabled={pageIndex === 0}
              data-testid="prediction-card-page-previous"
              aria-label="Previous page"
            >
              <Icon icon={IconName.ChevronLeft} size={12} />
            </FooterNavButton>
            <Text
              color="colorTextDefault"
              size="fontSizeTiny"
              whiteSpace="nowrap"
              data-testid="prediction-card-page-indicator"
            >
              {pageIndex + 1}/{pageCount}
            </Text>
            <FooterNavButton
              onClick={onNextPage}
              disabled={pageIndex >= pageCount - 1}
              data-testid="prediction-card-page-next"
              aria-label="Next page"
            >
              <Icon icon={IconName.ChevronRight} size={12} />
            </FooterNavButton>
          </>
        ) : null}
      </CardFooterPagination>
      <CardFooterSide>
        <Tooltip tooltip="External link (coming soon)" placement="top">
          <IconButton
            ghost
            dim
            size={FormControlSizes.Xxs}
            icon={IconName.ExternalLink}
            disabled
            data-testid="prediction-card-external-link"
            aria-label="Open event externally"
          />
        </Tooltip>
      </CardFooterSide>
    </CardFooter>
  );
}
